import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import { danger, gray, primary, white } from "../../colors";
import StepSlide from "../animation/StepSlide";
import { useState } from "react";
import PersonIcon from "../../assets/svg/PersonIcon";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import { Feather } from "@expo/vector-icons";
import { babyBoy, babyGirl } from "../../imports";
import CalendarIcon from "../../assets/svg/CalendarIcon";

import PlayIcon from "../../assets/svg/PlayIcon";

export default function TestDetailsHeader({
  childGender,
  childName,
  childId,
  type,
  childImage,
}) {
  
  return (
    <View
      style={{
        width: "94%",
        borderRadius: 15,
        backgroundColor: "#DEE1FF",
        padding: "3%",
        overflow: "hidden",
        minHeight: 120,
        marginVertical: 5,
      }}
    >
      <View style={{ flexDirection: "row" }}>
        <MyText style={{ fontSize: 25 }}>{`${translate("test")} ${
          type === "growth" ? translate("growth") : type
        }`}</MyText>
        <View style={{ flex: 1 }}></View>
      </View>
      <View style={{ flex: 1 }}></View>

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 10,
        }}
      >
        <View style={{ flex: 1 }}></View>
        <View
          style={{
            marginHorizontal: 6,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: white,
            borderRadius: 20,
            padding: 3,
          }}
        >
          <Image
            source={{ uri: childImage }}
            defaultSource={childGender === "male" ? babyBoy : babyGirl}
            style={{ width: 25, height: 25 }}
            resizeMode="contain"
          />
        </View>

        
        <MyText
          style={{
            fontSize: 13,
            color: gray,
            marginHorizontal: 2,
            maxWidth: 50,
          }}
        >
          {childName}
        </MyText>
      </View>
    </View>
  );
}
